import { EventEmitter } from 'eventemitter3';
const getBrokerCodeFromStorage = () => {
    try {
        return localStorage.getItem('brokerCode');
    }
    catch (error) {
        console.error("Error getting brokerCode from local storage: " + error);
        return null;
    }
};
const setBrokerCodeInStorage = (brokerCode) => {
    try {
        localStorage.setItem('brokerCode', brokerCode);
    }
    catch (error) {
        console.error("Error setting brokerCode from local storage: " + error);
    }
};
const createBrokerCodeStore = () => {
    let currentBroker = getBrokerCodeFromStorage();
    const eventEmitter = new EventEmitter();
    return {
        subscribe: (callback) => {
            eventEmitter.addListener('update', callback);
            return () => {
                eventEmitter.removeListener('update', callback);
            };
        },
        setCurrentBrokerCode: (brokerCode) => {
            currentBroker = brokerCode;
            setBrokerCodeInStorage(brokerCode);
            eventEmitter.emit('update');
        },
        getCurrentBrokerCode: () => currentBroker,
        clearCurrentBrokerCode: () => {
            try {
                localStorage.removeItem('brokerCode');
            }
            catch (error) {
                console.log("Error removing item from local storage: " + error);
            }
            currentBroker = null;
            eventEmitter.emit('update');
        },
    };
};
export const brokerCodeStore = createBrokerCodeStore();
export const setCurrentBrokerCode = (brokerCode) => {
    brokerCodeStore.setCurrentBrokerCode(brokerCode);
    const storedBrokerCode = getBrokerCodeFromStorage();
    if (storedBrokerCode !== brokerCode) {
        setBrokerCodeInStorage(brokerCode);
    }
};
export const clearCurrentBrokerCode = () => {
    brokerCodeStore.clearCurrentBrokerCode();
};
